import sc from 'states-cities-db';

export const COUNTRIES = sc.getCountries();

export const getCountryTelCode = country =>
  country !== '' &&
  country &&
  COUNTRIES.find(({ iso }) => iso === country).prefix;

export const getCountryCode = prefix =>
  prefix !== '' &&
  prefix &&
  COUNTRIES.find(({ prefix: p }) => p === prefix).iso;

export const getCountryIsoFromPhone = (phone?: string) => {
  if (!phone) return undefined;
  const normalized = String(phone)
    .trim()
    .replace(/[^\d+]/g, ''); // deja + y dígitos
  const matches = COUNTRIES.filter(
    c => c?.prefix && `+${normalized}`.startsWith(c.prefix)
  );
  if (matches.length === 0) return undefined;
  // preferir el prefijo más largo (ej +549 antes que +54)
  matches.sort((a, b) => String(b.prefix).length - String(a.prefix).length);
  return matches[0].iso;
};

/**
 * Bandera del país como emoji, a partir del ISO2.
 *
 * `states-cities-db` no trae la bandera, pero el emoji se arma con los dos "regional
 * indicator symbols" del ISO (A = U+1F1E6), así que no hace falta ningún asset ni otra
 * dependencia. Si el ISO no es válido devuelve vacío y el campo se ve sin bandera.
 */
export const getCountryFlag = (iso?: string | null): string => {
  if (!iso || iso.length !== 2) return '';

  return String.fromCodePoint(
    ...iso
      .toUpperCase()
      .split('')
      .map(char => 0x1f1e6 + char.charCodeAt(0) - 65)
  );
};
